import { ReactElement, useContext, useEffect, useState } from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import Sensors from './Sensors';
import UserInformation from './UserInformation';
import { ThemeContext } from '../context/theme.context';
import { useAuth } from '../context/auth.context';
import Timezone from './Timezone';

/**
 * Represents the navbar of the dashboard.
 * @returns A React element representing the Navbar component.
 */
export default function Navbar(): ReactElement {
  const { toggleTheme } = useContext(ThemeContext);
  const { authUser } = useAuth();
  const [params] = useSearchParams();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [tab, setTab] = useState('');
  const tabParam = params.get('tab');
  const showThemeToggle = false;
  const locaction = useLocation();

  const pathnames = locaction.pathname.split('/').filter((x) => x);

  useEffect(() => {
    if (tabParam) {
      setTab(tabParam);
    } else {
      setTab('');
    }
  }, [tabParam]);

  return (
    <header className="fixed top-0 z-40 w-full pl-12 sm:pl-16 bg-white dark:bg-background-700">
      <div className="flex mt-safe flex-grow items-center justify-between p-2 px-2 lg:px-4 md:border-b-gray-100 md:border-b md:dark:border-b-gray-800">
        <ol className="flex">
          <li>
            <Link
              to="/"
              className="text-grey-900 font-semibold text-xl dark:text-primary-100 pl-2 capitalize"
            >
              {pathnames.length ? (
                <>
                  <span className="underline">dashboard</span>
                  <span>{' >'}</span>
                </>
              ) : (
                <span>dashboard</span>
              )}
            </Link>
          </li>
          {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            const isLast = index === pathnames.length - 1;

            return isLast ? (
              <li
                className="text-grey-900 font-semibold text-xl dark:text-primary-100 pl-2 capitalize"
                key={to}
                aria-current="page"
              >
                <span>{(tab || value).replace(/-/g, ' ')}</span>
              </li>
            ) : (
              <li
                className="text-grey-900 font-semibold text-xl dark:text-primary-100 pl-2 capitalize"
                key={to}
              >
                <Link className="underline" to={to}>
                  {value.replace(/-/g, ' ')}
                </Link>{' '}
                {'>'}
              </li>
            );
          })}
        </ol>

        <div className="flex items-center px-1">
          {/* {showThemeToggle && (
            <button
              type="button"
              onClick={toggleTheme}
              className="hidden sm:flex border border-gray-200 p-1 lg:p-2 rounded text-semibold bg-gray-100 dark:bg-background-700 dark:text-gray-100 dark:border-gray-800 mr-2 lg:mr-6"
            >
              Change Theme
            </button>
          )} */}
          <div className="hidden sm:flex">
            <Timezone />
            <Sensors />
          </div>
          {authUser ? (
            <UserInformation />
          ) : (
            <Link
              to="/auth/login"
              className="hidden sm:flex border border-gray-200 px-5 py-1 lg:py-2 rounded text-semibold bg-gray-100 dark:bg-background-700 dark:text-gray-100 dark:border-gray-800 mr-2 lg:mr-6"
            >
              Login
            </Link>
          )}
        </div>
      </div>
      <div className="sm:hidden flex flex-wrap justify-between grow items-center p-2 px-4 border-b-gray-100 border-b dark:border-b-gray-800 gap-2">
        {showThemeToggle && (
          <button
            type="button"
            onClick={toggleTheme}
            className="border border-gray-200 p-2 w-full rounded text-semibold bg-gray-100 dark:bg-background-700 dark:text-gray-100 dark:border-gray-800"
          >
            Change Theme
          </button>
        )}
        <Sensors />
      </div>
    </header>
  );
}
